import React, { useEffect,useState} from 'react'
import { useNavigate } from 'react-router-dom'
import { LockOutlined, UserOutlined, SmileOutlined } from '@ant-design/icons'
import { Button, Checkbox, Form, Input, message, Space, notification } from 'antd'
import { captcha,checkCode,checkAccount,checkPassword } from '../../../utils/validator'
import Logo from '../../../components/Logo'
import { reload } from '../../../utils/utils'
import './index.scss'
import api from '../../../https/api'

export default function Login() {
  const navigate = useNavigate()
  const [code,setCode] = useState('')
  useEffect(() => {
    setCode(captcha())
  },[])

  const onFinish = async (values) => {
    values.account = btoa(values.account)
    values.password = btoa(values.password)
    const {data:{code,data,msg}} = await api.accountLogin(values)
    if(code === -1){
      setCode(captcha())
      return message.error(msg)
    }

    message.success(msg)
    if(!data.pwd_status){
      notification.warning({
        message: '温馨提示',
        description:'请及时修改初始密码，谨防账号泄露风险',
        placement:'topLeft',
        duration:null
      })
    }
    localStorage.setItem('crm_manage_account',JSON.stringify(data))
    reload(0)
    navigate('/index')
  }
  return (
      <div className='login'>
        <Logo width="300px"/>
        <Form
          name="normal_login"
          className="login-form"
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
        >
          <Form.Item
            name="account"
            rules={[
              {required: true,message: '请输入账号'},
              {validator:checkAccount}
            ]}
          >
            <Input 
              prefix={<UserOutlined className="site-form-item-icon" />} 
              placeholder="账号"
              autoComplete='off'
            />
          </Form.Item>
           <Form.Item
            name="password"
            rules={[
              {required: true,message: '请输入密码'},
              {validator:checkPassword}
            ]}
          >
            <Input.Password
              prefix={<LockOutlined className="site-form-item-icon" />}
              type="password"
              placeholder="密码"
            />
          </Form.Item>
          <Form.Item className='captcha'>
            <Space>
              <Form.Item 
                hasFeedback
                name="code" 
                rules={[
                  {required: true,message: '请输入验证码'},
                  {validator:checkCode}
                ]} 
              >
                <Input 
                  prefix={<SmileOutlined className="site-form-item-icon" />} 
                  maxLength={5} 
                  placeholder='验证码'
                  autoComplete='off'
                >
                </Input>
              </Form.Item>
              <img 
                className='img' 
                src={code} 
                alt='captcha'
                onClick={()=>setCode(captcha())}
                 />
            </Space>
          </Form.Item>
          <Form.Item name="remember" valuePropName="checked">
            <Checkbox>自动登录</Checkbox>
          </Form.Item>
          <Form.Item>
            <Button type="primary" htmlType="submit" className="login-form-button">
              登录
            </Button>
          </Form.Item>
        </Form>
      </div>
  )
}


// import React, { useEffect, useState, useCallback} from 'react'
// import { useNavigate } from 'react-router-dom'
// import { LockOutlined, UserOutlined, SmileOutlined } from '@ant-design/icons'
// import { Button, Checkbox, Form, Input, message, Space, notification } from 'antd'
// import { captcha,checkCode,checkAccount,checkPassword } from '../../../utils/validator'
// import Logo from '../../../components/Logo'
// import { reload } from '../../../utils/utils'
// import './index.scss'
// import api from '../../../https/api'

// export default function Login() {
//   const [form] = Form.useForm();
//   const navigate = useNavigate()
//   const [code,setCode] = useState('')
//   const [loading, setLoading] = useState(false);

//   // 生成验证码（使用useCallback避免不必要的函数创建）
//   const generateCaptcha = useCallback(() => {
//     // 清除输入的验证码
//     form.setFieldValue('code', '');
//     // 生成新验证码
//     return captcha();
//   }, [form]);

//   // 初始化验证码
//   useEffect(() => {
//     setCode(generateCaptcha())
//   },[generateCaptcha])

//   const onFinish = async (values) => {
//     try {
//       setLoading(true); // 开启加载状态，防止重复提交
//       values.account = btoa(values.account)
//       values.password = btoa(values.password)
//       const {data:{code,data,msg}} = await api.accountLogin(values)
//       if(code === -1){
//         // 验证失败刷新验证码
//         setCode(generateCaptcha());
//         message.error(msg);
//         return
//       }
//       // 初始密码提示
//       if(!data.pwd_status){
//         notification.warning({
//           message: '温馨提示',
//           description:'请及时修改初始密码，谨防账号泄露风险',
//           placement:'topLeft',
//           duration:null
//         })
//       }
//       localStorage.setItem('crm_manage_account',JSON.stringify(data))
//       reload(0)
//       navigate('/index')
//       // 登录成功处理
//       message.success(msg)
//     }catch (error) {
//       message.error('网络异常，请检查网络后重试');
//       setCode(generateCaptcha());
//     } finally {
//       setLoading(false); // 无论成功失败，关闭加载状态
//     }
//   }
//   return (
//       <div className='login'>
//         <Logo/>
        
//         <Form
//           form={form}
//           name="normal_login"
//           className="login-form"
//           initialValues={{ remember: true}}
//           onFinish={onFinish}
//           autoComplete="off" // 关闭自动完成，避免浏览器默认行为干扰
//         >
//           <Form.Item
//             name="account"
//             rules={[
//               {required: true,message: '请输入账号'},
//               {validator:checkAccount}
//             ]}
//           >
//             <Input 
//               prefix={<UserOutlined className="site-form-item-icon" />} 
//               placeholder="账号"
//               autoFocus // 自动聚焦，提升用户体验
//             />
//           </Form.Item>
//           <Form.Item
//             name="password"
//             rules={[
//               {required: true,message: '请输入密码'},
//               {validator:checkPassword}
//             ]}
//           >
//             <Input.Password
//               prefix={<LockOutlined className="site-form-item-icon" />}
//               placeholder="密码"
//             />
//           </Form.Item>


//           <Form.Item className='captcha'>
//             <Space>
//               <Form.Item 
//                 hasFeedback
//                 name="code" 
//                 rules={[
//                   {required: true,message: '请输入验证码'},
//                   {validator:checkCode}
//                 ]}
//               >
//                 <Input 
//                   prefix={<SmileOutlined className="site-form-item-icon" />} 
//                   maxLength={5} 
//                   placeholder='验证码'
//                   autoComplete='off'
//                 >
//                 </Input>
//               </Form.Item>
//               <img 
//                 className='img' 
//                 src={code} 
//                 alt='captcha'
//                 loading="lazy" 
//                 onClick={()=>setCode(captcha())}
//               />
//             </Space>
//           </Form.Item>

//           <Form.Item name="remember" valuePropName="checked"><Checkbox>自动登录</Checkbox></Form.Item>

//           <Form.Item>
//             <Button 
//               type="primary" 
//               htmlType="submit" 
//               block // 占满宽度，移动端更友好
//               loading={loading}
//               className="login-form-button">
//               登录
//             </Button>
//           </Form.Item>
//         </Form>
//       </div>
//   )
// }
